// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__32CbX","head":"ProcedureTableInfo_head__2zWJ3"};